import React from 'react';

export default function Oracle() {
  return (
    <div className="page-content fade-up">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <span className="section-label">Dual Attestation Network</span>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Oracle Status</div>
        </div>
        <span className="badge badge-green">● All Systems Normal</span>
      </div>

      <div className="grid-2" style={{ marginBottom: 20 }}>
        {/* Chainlink */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">Chainlink PoR</div>
            <span className="badge badge-muted">External</span>
          </div>
          <div className="data-row">
            <span className="data-label">NCD-001 Balance</span>
            <span className="data-value gold">$100,000,000</span>
          </div>
          <div className="data-row">
            <span className="data-label">Confirmed at</span>
            <span className="data-value">14:22 UTC</span>
          </div>
          <div className="data-row">
            <span className="data-label">AMTS / NCD Price</span>
            <span className="data-value">$7.50</span>
          </div>
          <div className="data-row">
            <span className="data-label">Next confirmation</span>
            <span className="data-value">6d 21h</span>
          </div>
          <div style={{ marginTop: 14 }}>
            <span className="badge badge-green" style={{ width: '100%', justifyContent: 'center' }}>✓ All Feeds Healthy</span>
          </div>
        </div>

        {/* Native validators */}
        <div className="card">
          <div className="card-header">
            <div className="card-title">Amitis Validators</div>
            <span className="badge badge-muted">Native</span>
          </div>
          <div className="data-row">
            <span className="data-label">NCD-001 Balance</span>
            <span className="data-value gold">$100,000,000</span>
          </div>
          <div className="data-row">
            <span className="data-label">Confirmed at</span>
            <span className="data-value">14:23 UTC</span>
          </div>
          <div className="data-row">
            <span className="data-label">Consensus</span>
            <span className="data-value green">18 / 21 validators</span>
          </div>
          <div className="data-row">
            <span className="data-label">Dissenting</span>
            <span className="data-value green">0 (all-time)</span>
          </div>
          <div style={{ marginTop: 14 }}>
            <span className="badge badge-green" style={{ width: '100%', justifyContent: 'center' }}>✓ Consensus Reached</span>
          </div>
        </div>
      </div>

      {/* Dual attestation result */}
      <div className="card" style={{ marginBottom: 20, background: 'rgba(96,165,250,0.05)', borderColor: 'rgba(96,165,250,0.2)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontWeight: 700, color: 'var(--blue)', marginBottom: 4 }}>⬡ Dual Attestation Confirmed</div>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>
              Both Chainlink PoR and Amitis validator network independently confirm $100,000,000 at the same timestamp.
              Zero discrepancies since genesis.
            </div>
          </div>
          <span className="badge badge-blue" style={{ flexShrink: 0, marginLeft: 20 }}>⬡ Verified</span>
        </div>
      </div>

      {/* History */}
      <div className="card">
        <div className="card-header">
          <div className="card-title">Attestation History — NCD-001</div>
          <span style={{ fontFamily: 'DM Mono, monospace', fontSize: 10, color: 'var(--green)' }}>0 discrepancies all-time</span>
        </div>
        {[
          { date: '2026-05-30 14:22 UTC', cycle: 'Weekly cycle #1', block: '847,293', val: '$100,000,000' },
          { date: '2026-05-23 14:18 UTC', cycle: 'Genesis confirmation', block: '741,102', val: '$100,000,000' },
        ].map((r, i) => (
          <div key={i} className="data-row">
            <div>
              <div style={{ fontSize: 13, fontWeight: 500 }}>{r.date}</div>
              <div style={{ fontFamily: 'DM Mono, monospace', fontSize: 10, color: 'var(--muted)' }}>{r.cycle} · Block #{r.block}</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontFamily: 'DM Mono, monospace', fontSize: 12, color: 'var(--gold)' }}>{r.val}</span>
              <span className="badge badge-blue">⬡ Dual</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
